import * as React from 'react';
import Radio from '@material-ui/core/Radio';

const CustomRadio = (props) => {
    return <Radio {...props} />;
};

export { CustomRadio as Radio };
